import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { IdlePreloadStrategy } from '@lm-shared';

import { APP_ROUTES } from './app-routing.module';
import { membershipTokenInterceptor } from './core/interceptors/membership-token.interceptor';

/** Root providers of the patient site (was AppModule + AppRoutingModule's RouterModule.forRoot). */
export const appConfig: ApplicationConfig = {
  providers: [
    // The site keeps zone-based change detection; Angular 21's bootstrapApplication would otherwise start zoneless.
    provideZoneChangeDetection(),
    provideRouter(APP_ROUTES, withInMemoryScrolling({ scrollPositionRestoration: 'top' }), withPreloading(IdlePreloadStrategy)),
    provideHttpClient(withInterceptors([membershipTokenInterceptor])),
  ],
};
